import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/skincare/hd-diagnostics"
    exact
    path="/business/showcase/skincare/hd-diagnostics"
    component={AsyncPage}
  />,
];
